export function isVietnamese(text) {
  // Vietnamese characters range in Unicode
  const vietnameseRange = /[\u00C0-\u1EF9\u1EFA-\u20AB\u20AC-\u20BD]/;

  // Check if the text contains Vietnamese characters
  return vietnameseRange.test(text);
}
